/**
 * Display name / email for void audit (`voidedBy` on update mutation).
 * Mirrors eatsbitsdesktop `OrderDetailsController.resolveVoidedByForAudit`.
 */
export function resolveVoidedByDisplay(user: unknown): string | null {
  if (user == null || typeof user !== "object") return null;
  const u = user as Record<string, unknown>;
  const su = u.storeUser as Record<string, string | undefined> | undefined;
  if (su && typeof su === "object") {
    const fn = su.firstName?.trim();
    const ln = su.lastName?.trim();
    if (fn && ln) return `${fn} ${ln}`;
    if (fn) return fn;
    if (ln) return ln;
    if (su.email?.trim()) return su.email.trim();
  }
  if (typeof window !== "undefined") {
    try {
      const raw = localStorage.getItem("employee");
      if (raw) {
        const e = JSON.parse(raw) as Record<string, string | undefined>;
        const fn = e.firstName?.trim();
        const ln = e.lastName?.trim();
        if (fn && ln) return `${fn} ${ln}`;
        if (fn) return fn;
        if (ln) return ln;
        if (e.email?.trim()) return e.email.trim();
      }
    } catch {
      /* ignore */
    }
  }
  return null;
}
